<template>
    <div>

        <CCard>

            <CCardHeader class="bgcolor grey-header d-flex">
                <CRow class="flex-flow-column">
                    <CCol>
                        <strong>{{ $t("report.title") }}</strong>
                    </CCol>
                    <p class="desc">
                        {{ $t("report.desc") }}
                    </p>
                </CRow>
                <div class="generate-ex-btn"  @click="showAlertModal(modalStatus,$t('report.downloadConfirm',{name:$t('report.title')}))" v-if="lsAgentReport!=''"><img src="@imgPath/img/svg/icons/pdf-icon.svg" alt="" ></div>
<!--                <CButton-->
<!--          @click="showAlertModal(modalStatus,$t('report.downloadConfirm',{name:$t('report.title')}))"-->
<!--          class="btn align-right btn-lit-blue btn-success mob-pricing-new-btn"-->
<!--        >{{ $t("report.download") }}</CButton>-->
            </CCardHeader>

            <CCardBody>


                <CRow class="bring_front" v-if="isSystemReport">

                    <CCol class="col-form-label col-sm-12">

                        <cAgent
                                v-model="agents"
                                agentType=null
                                label="Select Agency Name"
                                v-on:input="getAgentDetails"
                                class="bs-input"
                                :isMultiple="false"
                        />
                    </CCol>

                </CRow>

                <CRow class="report_filter-section">


<!--                    <CCol class="col-form-label col-sm-4 ">-->


<!--                        <cOrgCurrencyDp v-if="!isSystemReport"-->
<!--                                        v-on:input="onCurrencyChange"-->
<!--                                        :selValue="currency"-->
<!--                                        :label="$t('report.selectCurrency')"-->
<!--                                        :ctrlCode="'id'"-->
<!--                                        :isAllowEmpty="false"-->
<!--                                        :isShowCode="true"-->
<!--                                        :isMultiple="true"-->
<!--                                        :isSearchable="false"-->
<!--                                        :url="getOrgCurrencyServiceURL()"-->
<!--                                        rules="required"-->
<!--                                        :defaultCurrency="'USD'"-->
<!--                                        class="box-shadow_dropdown"-->

<!--                        />-->
<!--                    </CCol>-->
                    <!-- <CCol class="col-form-label col-sm-4 " v-if="agencyDet&&isSystemReport">
                        <strong>
                            {{$t('report.selectCurrency')}}
                        </strong>
                        <cDropDown v-if="isCurrChanged"
                                   class="dpTopalign"
                                   v-model="currency"
                                   :ctrlName="'code'"
                                   :ctrlCode="'name'"
                                   :isShowCode="false"
                                   :isMultiple="true"
                                   :isSearchable="true"
                                   :url="getCurrencyCodeURL()"
                                   rules="required"
                                   :selValue="currency"
                                   @input="onSelectedCurrency"
                                   class="box-shadow_dropdown"

                        />
                    </CCol> -->
                    <CCol md="12" class="col-form-label  d-flex align-center date-picker-report">

                        <div v-if="isSystemReport?agencyDet:true" class="date-picker-box-shadow">

                            <div class="date">
                                <div class="ext-date-wrapper box-shadow">
                                <label for=""> {{$t('report.slctDate')}}</label>
                                <!-- :endDate="new Date()" :startDate="getStartingDate()" -->
<v-md-date-range-picker
     :start-date="fromDate?fromDate.toString():new Date().toString()"
    :end-date="toDate?toDate.toString():new Date().toString()"
    :autoApply="true"
    :showYearSelect="true"
    :maxYear="getMaxYear()"
    :minYear="getMinYear()"
    @change="onChangeDate"
  >
  <template slot="input">
     <datePickerInput :fromDate="fromDate?fromDate:null" :toDate="toDate?toDate:null" :fromLabel="$t('report.fromLabel')" :toLabel="$t('report.toLabel')"/>
  </template>
</v-md-date-range-picker></div>
                                <!-- <HotelDatePicker :hoveringTooltip="false" :closeDatepickerOnClickOutside="false"
                                                 :startDate="getStartingDate()" 
                                                 :showYear="true" :startingDateValue="fromDate" :endingDateValue="toDate"
                                                
                                                 @check-out-changed="getToDate" :i18n="assigni18nObjByLang()"
                                                 :displayClearButton="false" :minNights="0" >
                                                 
                                                 </HotelDatePicker> -->
                                                 

                            </div>


                        </div>
                        <CButton v-if="isSystemReport?agencyDet:true" color="success"
                                 class="mt-auto mr-auto mob-w-100 mob-mt-10px"
                                 @click="isSystemReport?onShowSystemReport(): onShowAgentReport()">
                            {{$t('report.sumitBtn')}}

                        </CButton>

                    </CCol>


                </CRow>
                   

                <div class="pb-0px" v-if="lsAgentReport.length>0|isSubmitted" >

                  <!-- items-per-page-select  (removed items per page select- default item count (20) has given to it)-->

                    <cTable
                            :items="lsAgentReport"
                            :fields="lsAgentFields"
                            caption="TicketingQueue"
                            :itemsPerPage="maxCountForReport"
                            hover
                            pagination
                            :loading="isLoading"
                            class="usersTable border-grey manage-user-table table table-striped table-hover report_table mt-0"
                            id="user-manage-table"
                         
   @filtered-items-change="getFilteredAgentCount"
              @page-change="onPageChange"
              @pagination-change="onPaginationChange"
              :tableWatchList="reportTableWatchList"
             @getFields="onSaveColumns"
             manageColumn
            paginationLenOption
                    >
                    
                     <!-- <template #over-table>
                       <cManageColumns v-if="lsAgentFields&&lsAgentFields.length>0" :lsFields="lsAgentFields" @getFields="onSaveColumns"/>
               <cPaginationLenOption :paginationWatchLs="reportTableWatchList" :isReportPage="true" />
                     
              </template> -->
                        <template #no-items-view>
                            <div class="text-center my-5">
                                <h3 class="no-data-title">{{isLoading?"": $t("report.noRecordsFound") }}</h3>
                            </div>
                        </template>
                        <template #ts="{item}">
                            <td class="py-2">
                                <div v-if="item.ts!=''&&item.ts">
                                    {{item.ts|formatDateTime}}

                                </div>
                                <div v-else>
                                    {{item.ts}}

                                </div>
                            </td>
                        </template>
                        <template #transactionid="{item}">
                            <td class="py-2">
                                <div v-if="item&&item.transactionid">
                                    {{item.transactionid}}
                                </div>
                                <div v-else>
                                    {{''}}

                                </div>
                            </td>
                        </template>
                        <template #description="{item}">
                            <td class="py-2">
                                <div v-if="item&&item.description">
                                    {{item.description}}
                                </div>
                                <div v-else>
                                    {{''}}

                                </div>
                            </td>
                        </template>
                        <template #reference="{item}">
                            <td class="py-2">
                                <div v-if="item&&item.reference">
                                    {{item.reference}}
                                </div>
                                <div v-else>
                                    {{''}}

                                </div>
                            </td>
                        </template>
                        <template #orderid="{item}">
                            <td class="py-2">
                                <div v-if="item&&item.orderid">
                                    {{item.orderid}}
                                </div>
                                <div v-else>
                                    {{''}}

                                </div>
                            </td>
                        </template>
                        <template #currencycode="{item}">
                            <td class="py-2">
                                <div v-if="item&&item.currencycode">
                                    {{item.currencycode}}
                                </div>
                                <div v-else>
                                    {{''}}

                                </div>
                            </td>
                        </template>
                        <template #before_amount="{item}">
                            <td class="py-2">
                                <div v-if="item&&item.before_amount">

                                    {{item.before_amount|formatNumber(item.currencycode)}}
                                </div>
                                <div v-else>
                                    {{''}}

                                </div>
                            </td>
                        </template>
                        <template #credit="{item}">
                            <td class="py-2">
                                <div v-if="item&&item.credit">
                                    {{item.credit|formatNumber(item.currencycode)}}
                                </div>
                                <div v-else>
                                    {{''}}

                                </div>
                            </td>
                        </template>

                        <template #debit="{item}">
                            <td class="py-2">
                                <div v-if="item&&item.debit">
                                    {{item.debit|formatNumber(item.currencycode)}}
                                </div>
                                <div v-else>
                                    {{''}}

                                </div>
                            </td>
                        </template>
                        <template #after_amount="{item}">
                            <td class="py-2">
                                <div v-if="item&&item.after_amount">
                                    {{item.after_amount|formatNumber(item.currencycode)}}
                                </div>
                                <div v-else>
                                    {{''}}

                                </div>
                            </td>
                        </template>


                    </cTable>
                   
                </div>
                 
             
                


            </CCardBody>
            <cAlertModal
                v-if="isShowAlertModal"
                :buttonList="modalButton"
                :status="modalStatus"
                :isShowIcon="true"
                :show="isShowAlertModal"
                :desc="confirmTxt"
    ></cAlertModal>
    <div ref="pdfContent" class='d-none' id="pdfContent">
      <small v-if="userLogoDetail">
      <div>{{ $t("report.createdBy") + userLogoDetail.email}}</div>
      <div>{{$t("report.createdAt") + new Date() | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}</div></small>
      <!-- style="text-align: center" -->
      <div  v-if="agencyDet&&agencyDet.agencyname">
        <div>

      
        <h1 >{{ agencyDet.agencyname + "(" + agencyDet.b2bcode + ")"}}</h1>
        <p>{{ agencyDet.contact_address+', '+agencyDet.contact_city+', '+agencyDet.contact_state_name+' - '+agencyDet.contact_postalcode}}</p>
        <p>{{$t("report.email")+agencyDet.emailid }}</p>
        <p>{{ $t("report.contact")+agencyDet.mobile_code + agencyDet.mobile_number}}</p><br/>

        <!-- <p>{{'Transaction Report from ' + fromDate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS) + ' to ' + toDate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}</p> -->
        </div>
        <div style="text-align: center">
          <span>{{$t("report.transactionRpt")}} {{ fromDate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}</span> 
     <span>   {{$t("report.to")}}  {{toDate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}</span>
        </div>
      </div>

         <div  v-else-if="userLogoDetail">
           <div>

           
        <h1 >{{ userLogoDetail.agencyname + "(" + userLogoDetail.b2bcode + ")"}}</h1>
        <p>{{ userLogoDetail.address+', '+userLogoDetail.city+', '+userLogoDetail.state+' - '+userLogoDetail.postalCode}}</p>
        <p>{{$t("report.email")+userLogoDetail.email }}</p>
        <p>{{  $t("report.contact")+userLogoDetail.mobile_code + userLogoDetail.mobile_number}}</p><br/>

        <!-- <p>{{'Transaction Report from ' + fromDate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS) + ' to ' + toDate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}</p> -->
      </div>
      <div style="text-align: center">
<span>{{$t("report.transactionRpt")}} {{ fromDate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}</span> 
<span>   {{$t("report.to")}}  {{toDate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}</span>
      </div>
      </div>
      

    </div>
        </CCard>


    </div>
</template>

<script>
import {VMdDateRangePicker} from "material-vue-date-picker";
import {
  addDays,
  formatDate,
  subDays
} from "../../../src/util/date/dateFunctions";
import {addClassToBody,removeClassBody,handleJWT ,getErrorAlertValue,cloneDeep, cloneData,OrderByList} from "../../../src/util/util";

import {
    PATHNAME,
    COMPONENT_NAME,
    ALERT_MODAL_STATUS,ORDER,DATE_TIME_FORMAT
} from "../../../src/util/constants";
//import flightDatePicker from "vue-flight-datepicker";
import HotelDatePicker from 'vue-range-datechooser'
import cAgent from "../../components/form/cAgent";
// import nb from "../translations/validation/nb.json";
// import en from "../translations/validation/en.json";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base.js";
import SERVICE_URL from "../../../src/config/API_DATA";
// import cDropDown from "../../src/components/form/cDropDown";
// import cOrgCurrencyDp from "../../src/components/currency/cOrgCurrencyDp";
import apiGetAgentReport from "../../../src/services/apiGetAgentReport";
import apiGetSystemReport from "../../../src/services/apiGetSystemReport";

import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import { mapActions, mapGetters } from "vuex";
import cAlertModal from "../../components/form/cAlertModal"
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";

    import datePickerInput from "../../components/datePicker/datePickerInput";
    import cFullScreen from "../../components/cFullScreen"
import cManageColumns from "../../components/dataTable/cManageColumns";
import cTable from "../../components/dataTable/cTable";

export default {
    name: COMPONENT_NAME.REPORT,

     components: {
       //flightDatePicker,
       VMdDateRangePicker,
       HotelDatePicker,
        cAgent,
        cAlertModal,
        datePickerInput,
        cTable
        // cDropDown,
        // cOrgCurrencyDp
    },

    data (){
        return {
           reportTableWatchList:{
      filteredlistCount:null,
      itemsPerPage:BaseConfiguration.maxCountForReport,
       currentPageNum:1,
       orinalReportRes:null,
       totalItemCount:0
       },
            isSystemReport:false,
            fromDate: new Date(),
            toDate: new Date(),
            //selAgentDetail : null,
             agents:null,
             
             agencyDet: null,
             isCurrChanged:false,
            //  currency: null,
             currencyLs:[],
             lsAgentReport:[],
             isSubmitted:false,
             confirmTxt: null,
             modalButton: null,
             modalStatus: ALERT_MODAL_STATUS.INFO,
             isShowAlertModal: false,
            maxCountForReport: BaseConfiguration.maxCountForReport,
            isLoading:true,
            lsAgentFields:null
           // fullscreen: false
              
     

        }
    },
     computed: {


    
          DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
       ...mapGetters("sSysLogin", {
      ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),
    ...mapGetters("sAgtLogin", {
      AGENT_SIGNIN_RES: "GET_SIGNIN_RES"
    }),
       ...mapGetters("sDashBoard", {
                userLogoDetail: "GET_AGENT_LOGO_DET_RES",
            }),
      ...mapGetters("sSystemTopUp", {
            GET_SEL_AGENT_DEATAILS: "GET_SEL_AGENT_DEATAILS"
        }),
    },
     
    methods: {
//       toggle () {
//         this.$refs['fullscreen'].toggle() 
//         // recommended
//         // this.fullscreen = !this.fullscreen // deprecated
//       },
//  fullscreenChange (fullscreen) {
//         this.fullscreen = fullscreen
//       },
onSaveColumns(pFields) {
    try {
      if(BaseConfiguration.isDebug) console.log("onSaveColumns");
      this.lsAgentFields=pFields;
      

    } catch (err) {
            let body = Logger.buildRequest(
            COMPONENT_NAME.REPORT,
              "error in onSaveColumns",
              err.toString(),
              "onSaveColumns",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 
       getMinYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMinYear");
           retValue=(new Date().getFullYear()-10)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.REPORT,
                    "error in getMinYear",
                    err.toString(),
                    "getMinYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
      getMaxYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMaxYear");
           retValue=(new Date().getFullYear()+1)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.REPORT,
                    "error in getMaxYear",
                    err.toString(),
                    "getMaxYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
        //      getMaxDate() {
        //  let retValue;
        //   try {
        //     if(BaseConfiguration.isDebug) console.log("getMaxDate");
        //     // console.error(new Date(new Date().getFullYear(), 11, 31))
        //    retValue=new Date(new Date().getFullYear(), 11, 31);
      
        //   } catch (err) {
        //           let body = Logger.buildRequest(
        //             FILE_NAME.REPORT,
        //             "error in getMaxDate",
        //             err.toString(),
        //             "getMaxDate",
        //             LOG_TYPE.ERROR
        //           );
        //           Logger.getResponse(body);
        //         }
        //     return retValue;
        //   }, 
      onChangeDate(pDateList) {
          try {
            if(BaseConfiguration.isDebug) console.log("onChangeDate");
          //  console.error(pDateList)
           this.fromDate=pDateList[0]._d;
             this.toDate=pDateList[1]._d;
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.REPORT,
                    "error in onChangeDate",
                    err.toString(),
                    "onChangeDate",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 
    onPaginationChange(pItemsPerPage) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPaginationChange");
           this.reportTableWatchList.itemsPerPage=this.maxCountForReport;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.REPORT,
                  "error in onPaginationChange",
                  err.toString(),
                  "onPaginationChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    onPageChange(pPageNum) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPageChange");
    this.reportTableWatchList.currentPageNum=pPageNum;
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.REPORT,
                  "error in onPageChange",
                  err.toString(),
                  "onPageChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 

    getFilteredAgentCount(pFilteredItems) {
        try {
          if(BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
         this.reportTableWatchList.filteredlistCount=pFilteredItems.length;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.REPORT,
                  "error in getFilteredAgentCount",
                  err.toString(),
                  "getFilteredAgentCount",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 
    showAlertModal(status, val) {

      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;
      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("report.cancel"),
            func: this.toggleShowAlertModal
          },
          {
            name: this.$t("report.yes"),
            func: this.createPdf
          }
        ];
      } else if (status == ALERT_MODAL_STATUS.SUCCESS) {
        this.modalButton = [
          {
            name: this.$t("report.ok"),
            func: this.toggleShowAlertModal
          }
        ];
      }
      this.confirmTxt = val;
    },

    toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
      this.modalStatus = ALERT_MODAL_STATUS.INFO;
    },

    createPdf() {
        try {
          if(BaseConfiguration.isDebug) console.log("createPdf");

          this.toggleShowAlertModal();
           let pdfDate=this.$options.filters.formatDate(new Date()); 
           let pdfName = this.$t("report.title")+' -'+pdfDate;
           var doc = new jsPDF();
           const contentHtml = this.$refs.pdfContent.innerHTML;
           doc.fromHTML(contentHtml, 10, 10, {
                     width: 145
           });
           //doc.text(this.$t("report.title"), 10, 10)
          //     doc.fromHTML(contentHtml, 10, 10, {
          //            width: 170
          //  });
          //  //doc.text(this.$t("report.title"), 10, 10)
          //  doc.autoTable({ 
          //    margin: { top: 90 },
           doc.autoTable({ 
               styles : {
         fontSize : 6.6,
        valign : 'top',
        overflow : 'linebreak',
        cellWidth : 'auto',
        cellPadding : 1,
        width:800,
        //rowHeight :0
    },
            //  Padding:{top: 10, right: 10, bottom: 10, left: 10},
             margin: {  top: 90,
             bottom: 20,
             left:10,right:10,
             width: 1500},
            columns: this.getPdfField(),
            body:  this.getPdfBody(this.lsAgentReport)
           });
           doc.save(pdfName + '.pdf');

           this.showAlertModal(ALERT_MODAL_STATUS.SUCCESS,this.$t('report.downldSuccess'))
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.REPORT,
                  "error in createPdf",
                  err.toString(),
                  "createPdf",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    }, 
    getPdfBody(pLsAgentReport) {
                let retValue;

        try {
          if(BaseConfiguration.isDebug) console.log("getPdfBody");
          let lsAgentReport=cloneDeep(pLsAgentReport);
          for(let i=0;i<lsAgentReport.length;i++){
            if(lsAgentReport[i].ts&&lsAgentReport[i].ts!=""){
                 lsAgentReport[i].ts = this.$options.filters.formatDateTime(lsAgentReport[i].ts);

            }

          }
          retValue=lsAgentReport;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.REPORT,
                  "error in getPdfBody",
                  err.toString(),
                  "getPdfBody",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    getPdfField(){
      let retValue;

      retValue = [
              { header: this.$t("report.transactionDate"), dataKey: 'ts' },
              { header: this.$t("report.transactionId"), dataKey: 'transactionid' },
              { header: this.$t("report.description"), dataKey: 'description' },
              { header: this.$t("report.reference"), dataKey: 'reference' },
              { header: this.$t("report.transType"), dataKey: 'transaction_type_desc' },
              { header: this.$t("report.orderId"), dataKey: 'orderid' },
              { header: this.$t("report.currency"), dataKey: 'currencycode' },
              { header:this.agencyDet&&this.agencyDet.agenttype==2?this.$t("report.openingDueAmt"):this.$t("report.openingBalance"), dataKey: 'before_amount' },
              { header: this.$t("report.credit"), dataKey: 'credit' },
              { header: this.$t("report.debit"), dataKey: 'debit' },
              { header:this.agencyDet&&this.agencyDet.agenttype==2? this.$t("report.closingDueAmt"): this.$t("report.closingBalance"), dataKey: 'after_amount' },
            ];
       
       return retValue;
    },

       getAgentDataField(){
           if (BaseConfiguration.isDebug) console.log("getAgentDataField");
           return [
        {
          key: "ts",
          label: this.$t("report.transactionDate"),
          isLocked: true,
        },
         {
          key: "transactionid",
          label: this.$t("report.transactionId"),
          isLocked: true,
        },
         {
          key: "description",
          label: this.$t("report.description"),
          isLocked: false
        },
         {
          key: "reference",
          label: this.$t("report.reference"),
          isLocked: false
        },
        {
          key: "transaction_type_desc",
          label: this.$t("report.transType"),
          isLocked: true,
        },
        {
        
          key: "orderid",
          label: this.$t("report.orderId"),
          isLocked: true,
        },
         {
        
          key: "currencycode",
          label: this.$t("report.currency"),
          isLocked: true,
        },
        {
          key: "before_amount",
          label: this.agencyDet&&this.agencyDet.agenttype==2?this.$t("report.openingDueAmt"):this.$t("report.openingBalance"),
          isLocked: true,
        },
        
        {
          key: "credit",
          label: this.$t("report.credit"),
          isLocked: true,
        },
        {
          key: "debit",
          label: this.$t("report.debit"),
          isLocked: true,
        },
         {
          key: "after_amount",
          label:this.agencyDet&&this.agencyDet.agenttype==2?this.$t("report.closingDueAmt"): this.$t("report.closingBalance"),
          isLocked: true,
        },
       
      ];

        },
      getStartingDate() {
          try {
            if(BaseConfiguration.isDebug) console.log("getStartingDate");
          // let date=  subDays(new Date(),60000);
          let date=new Date(null);
          return date;
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.REPORT,
                    "error in getStartingDate",
                    err.toString(),
                    "getStartingDate",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
          }, 
 ///to get currency service url
    // getOrgCurrencyServiceURL() {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
    //     return SERVICE_URL.GET_ORG_CURRENCY;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.REPORT,
    //       "error while getting currency  service url",
    //       err.toString(),
    //       "getCurrencyServiceURL",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },
          ///to change currency
    // onCurrencyChange(selCurrencyObj) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onCurrencyChange");

    //     this.currency = selCurrencyObj;        
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.REPORT,
    //       "error while changing currency",
    //       err.toString(),
    //       "onCurrencyChange",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },
    //      ///emit from cDropDown
    // onSelectedCurrency(pCurrency) {
    //   try {
    //     this.currency = pCurrency;

    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.REPORT,
    //       "error while emitting selected currency from cDropDown Component",
    //       err.toString(),
    //       "onSelectedCurrency",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },
         ///to get a currency code url
    // getCurrencyCodeURL: function() {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getCurrencyCodeURL");
    //     return SERVICE_URL.GET_AGENT_SELECTED_CURRENCY;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //      COMPONENT_NAME.REPORT,
    //       "error in currency code url",
    //       err.toString(),
    //       "getCurrencyCodeURL",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

       async getAgentDetails(pAgentDetails) {

            try {
              if(BaseConfiguration.isDebug) console.log("getAgentDetails");
              if(pAgentDetails){
        if (BaseConfiguration.isDebug) console.log(" getAgentDetails");
        // this.isCurrChanged = false;
      this.isLoading=true;
        this.agencyDet = pAgentDetails;
        this.lsAgentReport=[];
        if(this.isSystemReport){
                  await  this.onShowSystemReport();

        }else{
          await  this.onShowAgentReport();
        }
         if(this.isLoading){
           this.isLoading=false;
         }
        
        
        // if (this.agencyDet.b2bCompanyFinancess.length > 0) {
        //   this.currency = this.agencyDet.b2bCompanyFinancess[0].currencycode;

        // } else {
        //   this.currency = null;
        // }
        // let that = this;
        // setTimeout(function() {
        //   that.isCurrChanged = true;
        // });
        }
          

            } catch (err) {
                    let body = Logger.buildRequest(
                      COMPONENT_NAME.REPORT,
                      "error in getAgentDetails",
                      err.toString(),
                      "getAgentDetails",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
            }, 
        
        getFromDate(date){
            if (BaseConfiguration.isDebug) console.log("getFromDate");
            this.fromDate=date;

        },
        getToDate(date){
            if (BaseConfiguration.isDebug) console.log("getToDate");
            this.toDate=date;
        },
      async  getAgentReport(pFromDate,pToDate) {
                 let retValue;
            try {
              if(BaseConfiguration.isDebug) console.log("getAgentReport");
       
                  let agentReportReq= apiGetAgentReport.buildRequest(pFromDate,pToDate);
                  if(agentReportReq)
                  {
                    
                    let agentReportRes=await apiGetAgentReport.getResponse(agentReportReq);
                    if(agentReportRes){
                      if (VALIDATE_SUCCESS_RES(agentReportRes)) {//VALIDATE_SUCCESS_RES(agentReportRes)
                           retValue=agentReportRes.data.data;

                      }
                      else {
            //if status error
            retValue = null;
            let error = getErrorMessage(agentReportRes);
          
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);

              
            }
          }
                    }

                  }

        
            } catch (err) {
                    let body = Logger.buildRequest(
                      COMPONENT_NAME.REPORT,
                      "error in getAgentReport",
                      err.toString(),
                      "getAgentReport",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              return retValue;
            }, 

             async  getSystemReport(pFromDate,pToDate,pB2bId) {
                 let retValue;
            try {
              if(BaseConfiguration.isDebug) console.log("getSystemReport");
       
                  let systemReportReq= apiGetSystemReport.buildRequest(pFromDate,pToDate,pB2bId);
                  if(systemReportReq)
                  {
                    
                    let systemReportRes=await apiGetSystemReport.getResponse(systemReportReq);
    
                    if(systemReportRes){
                      if (VALIDATE_SUCCESS_RES(systemReportRes)) {//VALIDATE_SUCCESS_RES(systemReportRes)
                           retValue=systemReportRes.data.data;

                      }
                      else {
            //if status error
            retValue = null;
            let error = getErrorMessage(systemReportRes);
          
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);

              
            }
          }
                    }

                  }

        
            } catch (err) {
                    let body = Logger.buildRequest(
                      COMPONENT_NAME.REPORT,
                      "error in getSystemReport",
                      err.toString(),
                      "getSystemReport",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              return retValue;
            }, 
            formatCurrency(pCurrency) {
                try {
                  if(BaseConfiguration.isDebug) console.log("formatCurrency");
                  let currencyLs=[];
                  if(pCurrency){
                  if(pCurrency.constructor==Array){
                    for(let i=0;i<pCurrency.length;i++){
                      if(pCurrency[i].hasOwnProperty('currency_code')){
                        currencyLs.push(pCurrency[i].currency_code.code);
                      }else if(pCurrency[i].hasOwnProperty('code')){
                        currencyLs.push(pCurrency[i].code);
                      }
                    }
                  }else if(pCurrency.constructor==Object){
                     if(pCurrency.hasOwnProperty('currency_code')){
                        currencyLs.push(pCurrency.currency_code.code);
                      }else if(pCurrency.hasOwnProperty('code')){
                        currencyLs.push(pCurrency.code);
                      }
                  }else{
                    currencyLs.push(pCurrency);
                  }

                }
                return currencyLs;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.REPORT,
                          "error in formatCurrency",
                          err.toString(),
                          "formatCurrency",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
                }, 
                getAgentReportLs(pAgentReport) {
                    let retAgentRepList=[];
                    try {
                      if(BaseConfiguration.isDebug) console.log("getAgentReportLs");
                                               let paginationLenVal=0;

                      for(let i=0;i<Object.keys(pAgentReport).length;i++){
                        if(Object.keys(pAgentReport)[i]!='Reportparam'&&Object.keys(pAgentReport)[i]!='reportdata'){
                          //  ///for sorting *Start
                          //  pAgentReport[Object.keys(pAgentReport)[i]]=OrderByList(pAgentReport[Object.keys(pAgentReport)[i]],this.getPropToSortAgents,ORDER.DESC);
                          ///for sorting *End
                          
                           let totalAmount=0;
                          for(let j=0;j<pAgentReport[Object.keys(pAgentReport)[i]].length;j++){
                            totalAmount+=Number(pAgentReport[Object.keys(pAgentReport)[i]][j].credit);
                            paginationLenVal=paginationLenVal+1;
                            
                            pAgentReport[Object.keys(pAgentReport)[i]][j].paginationLenVal=paginationLenVal;
                           retAgentRepList.push(pAgentReport[Object.keys(pAgentReport)[i]][j]);
                          }
                                 

                          let comValueToEmptyObj=cloneDeep(pAgentReport[Object.keys(pAgentReport)[i]][pAgentReport[Object.keys(pAgentReport)[i]].length-1]);
                          
                          for(let m=0;m<Object.keys(comValueToEmptyObj).length;m++){
                            // if(!(Object.keys(comValueToEmptyObj)[m].hasOwnProperty('currencycode'))){
                             comValueToEmptyObj[Object.keys(comValueToEmptyObj)[m]]='';
                            // }

                          }
                           let totalLength=pAgentReport[Object.keys(pAgentReport)[i]].length;
                           let calculatedNum=totalLength/this.maxCountForReport;
                           let indexUntilDot=calculatedNum.toString().indexOf(".");
                           let valueAfterDot=calculatedNum.toString().slice(indexUntilDot+1, calculatedNum.toString().length);
                           let addedRationalNum='0.'+valueAfterDot;
                          let emptyObjLength=this.maxCountForReport-( Number(addedRationalNum)*this.maxCountForReport);
                          for(let k=0;k<emptyObjLength;k++){
                            // if(k==emptyObjLength-1){
                            //   let addTotalToObj=cloneData(comValueToEmptyObj);
                            //   addTotalToObj['after_amount']=totalAmount;
                            //    retAgentRepList.push(addTotalToObj);
                            // }else{
                            retAgentRepList.push(comValueToEmptyObj);

                            // }
                          }
                        
                        }
                      }
                      this.reportTableWatchList.totalItemCount=paginationLenVal;
                     
                 
                    } catch (err) {
                            let body = Logger.buildRequest(
                              COMPONENT_NAME.REPORT,
                              "error in getAgentReportLs",
                              err.toString(),
                              "getAgentReportLs",
                              LOG_TYPE.ERROR
                            );
                            Logger.getResponse(body);
                          }
                      return retAgentRepList;
                    }, 
        
        
        getPropToSortAgents(pAgent) {
        try {
          if(BaseConfiguration.isDebug) console.log("getPropToSortAgents");
          if(pAgent.ts){
      return pAgent.ts.toLowerCase();

          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.REPORT,
                  "error in getPropToSortAgents",
                  err.toString(),
                  "getPropToSortAgents",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
                    
      async  onShowAgentReport(){
        try{
           if(BaseConfiguration.isDebug) console.log("onShowAgentReport");
   this.isSubmitted=true;
        let fromDate=formatDate(this.fromDate,DATE_TIME_FORMAT.API_DATE_FORMAT);
        let toDate=formatDate(this.toDate,DATE_TIME_FORMAT.API_DATE_FORMAT);
        // let retCurrencyLs=this.formatCurrency(this.currency);
        // this.currencyLs=retCurrencyLs;
         this.lsAgentReport=[];
        
        let retAgentReport=await this.getAgentReport(fromDate,toDate);

        if(retAgentReport){
       let retAgentReportList= this.getAgentReportLs(retAgentReport);
       this.lsAgentReport=retAgentReportList;
        this.reportTableWatchList.orinalReportRes=cloneDeep( this.lsAgentReport);

        }
          if(this.isLoading){
           this.isLoading=false;
         }
        }
        catch (err) {
                    let body = Logger.buildRequest(
                     COMPONENT_NAME.REPORT,
                      "error in onShowAgentReport",
                      err.toString(),
                      "onShowAgentReport",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
        
        },
      async  onShowSystemReport() {
            try {
              if(BaseConfiguration.isDebug) console.log("onShowSystemReport");
            if(this.agencyDet){
              this.isSubmitted=true;
               let fromDate=formatDate(this.fromDate,DATE_TIME_FORMAT.API_DATE_FORMAT);
        let toDate=formatDate(this.toDate,DATE_TIME_FORMAT.API_DATE_FORMAT);
        // let retCurrencyLs=this.formatCurrency(this.currency);
        // this.currencyLs=retCurrencyLs;
         this.lsAgentReport=[];
        
        let retSystemReport=await this.getSystemReport(fromDate,toDate,this.agencyDet.b2bid);
        if(retSystemReport){
       let retSystemReportList= this.getAgentReportLs(retSystemReport,this.currencyLs);
       this.lsAgentReport=retSystemReportList;
        this.reportTableWatchList.orinalReportRes=cloneDeep( this.lsAgentReport);

        }
           if(this.isLoading){
           this.isLoading=false;
         }
            }
        
            } catch (err) {
                    let body = Logger.buildRequest(
                     COMPONENT_NAME.REPORT,
                      "error in onShowSystemReport",
                      err.toString(),
                      "onShowSystemReport",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
            }, 
         assigni18nObjByLang() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat")
          ],
          "check-in": this.$t("flightDatePicker.checkIn"),
          "check-out":"",
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
          ]
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.REPORT,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    },
     beforeCreate() {    
   addClassToBody(COMPONENT_NAME.REPORT);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
    async created(){
      
     this.lsAgentFields=this.getAgentDataField();
      if(this.AGENT_SIGNIN_RES){
       this.isSystemReport=false;
       this.agencyDet={};
       this.agencyDet.agenttype=this.AGENT_SIGNIN_RES.logoDetails.agenttype;
      }else{
        this.isSystemReport=true;
    //   if(this.GET_SEL_AGENT_DEATAILS){
    //     this.agencyDet=this.GET_SEL_AGENT_DEATAILS;
    //  if(this.agencyDet){
    //     this.agents={
    //             "b2bid": this.agencyDet.b2bid,
    //             "b2bcode": this.agencyDet.b2bcode,
    //             "agencyname": this.agencyDet.agencyname,
    //             "contact_city": this.agencyDet.contact_city,
    //             "isactive": true
    //         };
    //       await  this. onShowSystemReport();
    //     }
    //   }
       
      }
      
   
    }

}
</script>